import { createContext, useContext, useState } from "react";

export const NavbarContext = createContext();

export const useNavbar = () => {
  const context = useContext(NavbarContext);
  if (!context) {
    throw new Error("use context must be used in navbarprovider");
  }
  return context;
};

export function NavbarProvider({ children }) {
  const [navbarIsOpen, setnavbarIsOpen] = useState(false);
  
  function openNavbar() {
    setnavbarIsOpen(true);
  }
  function closeNavbar() {
    setnavbarIsOpen(false);
  }
  const value = {
    closeNavbar,
    openNavbar,
    navbarIsOpen,
  };
  return (
    <NavbarContext.Provider value={value}>{children}</NavbarContext.Provider>
  );
}
